// Маршруты клиента. `/join/<токен>` — лёгкий режим для приглашения: сервер отдаёт на любой путь
// `index.html`, поэтому ссылка из письма открывается сразу нужным экраном.

import { createRouter, createWebHistory, type RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  { path: "/", name: "chats", component: () => import("./screens/ChatsScreen.vue") },
  { path: "/chat/:id", name: "chat", component: () => import("./screens/ChatsScreen.vue") },
  { path: "/directory", name: "directory", component: () => import("./screens/DirectoryScreen.vue") },
  { path: "/settings", name: "settings", component: () => import("./screens/SettingsScreen.vue") },
  { path: "/join/:token", name: "join", component: () => import("./screens/JoinScreen.vue") },
  // Встреча по ссылке: сюда попадает внешний участник после входа гостем.
  { path: "/room/:token", name: "room", component: () => import("./screens/RoomScreen.vue") },
  // Лобби со стороны того, кто впускает.
  { path: "/lobby/:id", name: "lobby", component: () => import("./screens/LobbyScreen.vue") },
  { path: "/:rest(.*)", redirect: "/" },
];

export const router = createRouter({ history: createWebHistory(), routes });
